module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightclear-df4275ae4966694e68f88c837c9b8a11.svg";